<template>
  <div class="m-reward-dialog dialog">
    <div class="digest">
      <p class="top">
        <span>主题：</span>
        <span class="switch-btn" @click="switchHandle">切换主题</span>
      </p>
      <div class="content-box">
        <p class="broadcast-content">{{ info.txt }}</p>
      </div>
    </div>
    <div class="input-box">
      <el-input size="small" type="number" step="1" min="1" v-model.number="money">
        <template slot="prepend">悬赏金额</template>
      </el-input>
      <div class="total-box">
        <p>
          <span class="label">合计:</span>
          <span class="price">¥{{ total }}</span>
        </p>
        <p style="font-size: 12px;">(¥{{ (this.money || 0).toFixed(2) }} + ¥{{ (this.money * 0.2).toFixed(2) }})</p>
      </div>
    </div>
    <div class="tip-box">
      <pre>
悬赏说明：
1.如果希望群友回答自己的问题，可以发起一个悬赏主题。
2.发布悬赏金额必须大于1元，可手动设置的悬赏金额作为奖励给予答者。</pre
      >
    </div>
    <el-button type="warning" :loading="loading" @click="payment">发布悬赏</el-button>
  </div>
</template>
<script>
import Pay from "@/api/pay";
import Bus from "@/components/Bus";
export default {
  data() {
    return {
      money: 1,
      loading: false,
      url: "",
      orderId: "",
      base64: ""
    };
  },
  computed: {
    total() {
      if (this.money) {
        return (this.money + this.money * 0.2).toFixed(2) || 0;
      } else {
        return 0;
      }
    }
  },
  methods: {
    async payment() {
      await Pay.postReward({
        id: this.info.msgId,
        amount: this.money
      }).then(res => {
        Bus.$emit("showPayQR", res.PayUrl);
        this.$emit("update:visible", false);
      });
    }
  },
  props: {
    visible: Boolean,
    info: Object,
    switchHandle: {
      type: Function,
      default: null
    }
  }
};
</script>
<style lang="scss">
.m-reward-dialog {
  position: relative;
}
</style>
